@if(currentOffer()) {
@switch (mediaService.media()) {
@case ('xs') {
<ng-container *ngTemplateOutlet="mobileoffer"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="mobileoffer"></ng-container>
}
@case ('md') {
<ng-container *ngTemplateOutlet="mobileoffer"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="desktopoffer"></ng-container>
}
}
}

<ng-template #mobileoffer>
    <div class="offerwrappermobile">
        <div class="offerbodymobile" [style.background-color]=" showitem() ? '#fee0cf' : ''" (click)="openItem($event)">
            <div class="bosysavatar">
                <mat-icon>open_in_new</mat-icon>
            </div>
            @if(showitem()) {
            <span>
                Buchen
            </span>
            }
        </div>
        @if(showitem()) {
        <div class="namewrapper">
            <ng-container *ngTemplateOutlet="btns"></ng-container>
        </div>
        }
    </div>
</ng-template>
<ng-template #desktopoffer>
    <div class="offerwrapper">
        <div class="offerbody">
            <span>
                Mein Angebot
            </span>
        </div>
        <div class="namewrapper">
            <div class="bosyshoteltitle">
                <span class="bosyshoteltitle">{{currentOffer().name}}</span>
                <div class="bosyshotelsunmesurement">
                    @for (cat of categoryAr(); track $index) {
                    @if(cat === 1) {
                    <div class="sunfilled"></div>
                    } @else {
                    <div class="sununfilled"></div>
                    }
                    }
                </div>
            </div>
            <div class="bosyshoteldatewrapper">
                <span>{{currentOffer().from}} - {{currentOffer().to}}</span>
                <span>{{currentOffer().duration}}</span>
            </div>
            <span class="bosyshotellocationwrapper" [innerHTML]="currentOffer().location"></span>
            <span class="bosyshoteltextwrapper" [innerHTML]="currentOffer().text"></span>
            <div class="bosyshotelinfowrapper">
                <img alt="logo" loading="lazy" class="bosyshotellogo"
                    [src]="currentOffer().logo">
                <div class="bosyshotelpricewrapper">
                    <span class="bosyshotelprice" [innerHTML]="currentOffer().price"></span>
                    <span class="bosyshotelpricetype" [innerHTML]="currentOffer().pricetype"></span>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="btns"></ng-container>
        </div>

    </div>
</ng-template>

<ng-template #btns>
    <div class="bosyshotelbuttonwrp">
        @if(myoffer()?.book_form === 1) {
        <button class="bosyshotelbutton" (click)="gotobookingline()">IM REISEBÜRO BUCHEN</button>
        }

        @if(myoffer()?.book_ibelink?.length > 0) {
        <button class="bosyshotelbutton" (click)="gotoUrl()">
            <span>ONLINE SELBST BUCHEN</span>
            <mat-icon>open_in_new</mat-icon>
        </button>
        }
    </div>
</ng-template>